import { i18n as rosetta } from '../../libs/i18n';
import { SEARCH_BY_COUNTY_SUFFIX, SEARCH_QUERY_GENERIC } from '../consts';
import { IOffice } from '../model/office.model';
import {
  generateUrlFromSearchOption,
  SearchOption,
} from './searchOption.utils';
import { slugifySearchQuery } from './searchQuery.utils';
import { SellHouseOption } from './sellHouse.utils';

const getQueriesBySheetName = (queries: string[], sheetName: string) => {
  return queries.filter((query) => {
    return (
      (process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production' &&
        !!rosetta.t(`dynamic.${sheetName}.${query}.production`)) ||
      rosetta.t(`dynamic.${sheetName}.${query}.production`) === 'TRUE'
    );
  });
};

export const getSellHouseOptionsBySheetName = (
  searchOptions: SearchOption[],
  sheetName: string
): SellHouseOption[] => {
  const queries = Array.from(
    new Set(searchOptions.map((s) => generateUrlFromSearchOption(s)))
  );

  return getQueriesBySheetName(queries, sheetName)
    .map((query) => {
      const searchOptionIndex = searchOptions
        .map((s) => generateUrlFromSearchOption(s))
        .findIndex((s) => s === query);
      return {
        query,
        text:
          searchOptionIndex >= 0
            ? searchOptions[searchOptionIndex].text
            : undefined,
      };
    })
    .filter(({ text }) => !!text);
};

export const getOfficesByCountyPageQueries = (offices: IOffice[]): string[] => {
  let queries = [
    ...Array.from(
      new Set(
        offices.map(
          (office) =>
            `${
              slugifySearchQuery(office.province) + SEARCH_BY_COUNTY_SUFFIX
            }/${slugifySearchQuery(office.city)}`
        )
      )
    ),
    ...Array.from(
      new Set(
        offices.map(
          (office) =>
            slugifySearchQuery(office.province) + SEARCH_BY_COUNTY_SUFFIX
        )
      )
    ),
  ];
  queries = getQueriesBySheetName(queries, 'officesByCountyPage');
  queries.sort((a, b) => -(a.split('/').length - b.split('/').length));
  return queries;
};

export const getCapitalCitiesQueries = (queries: string[]): string[] =>
  queries
    .map((query) => {
      const capitalCity = (rosetta.table('es')['dynamic'][
        'officesByCountyPage'
      ][query]['capitalCity'] || '') as string;
      return queries.includes(`${query}/${capitalCity.toLowerCase()}`)
        ? `${query}/${capitalCity}`
        : null;
    })
    .filter((query) => !!query);

export const getOfficesByCountyPageSheetQueries = (
  includeCapitalCities = false
): string[] => {
  let queries = Object.keys(
    rosetta.table('es')['dynamic']['officesByCountyPage']
  ).filter((q) => q !== SEARCH_QUERY_GENERIC);
  if (!includeCapitalCities) {
    const capitalCitiesQueries = getCapitalCitiesQueries(queries);
    queries = queries.filter((q) => !capitalCitiesQueries.includes(q));
  }

  if (process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production') {
    return queries;
  }

  return queries.filter(
    (q) => rosetta.t(`dynamic.officesByCountyPage.${q}.production`) === 'TRUE'
  );
};

export const getSearchPageUrlsMap = (): Record<
  string,
  Record<string, string>
> => {
  return rosetta.table('es')['dynamic']['searchPageUrls2'] as Record<
    string,
    Record<string, string>
  >;
};
